import React, { CSSProperties } from "react";

interface GoogleMapExportProps {
  embedUrl?: string;
  address?: string;
  height?: number;
  width?: number;
  align?: "left" | "center" | "right";
  borderRadius?: number;
  showAddress?: boolean;
}

export const GoogleMapExport: React.FC<GoogleMapExportProps> = ({
  embedUrl = "",
  address = "Bangkok, Thailand",
  height = 400,
  width = 100,
  align = "center",
  borderRadius = 8,
  showAddress = true,
}) => {
  const wrapperStyle: CSSProperties = {
    padding: "16px",
    width: `${width}%`,
    marginLeft: align === "center" ? "auto" : align === "right" ? "auto" : 0,
    marginRight: align === "center" ? "auto" : align === "left" ? "auto" : 0,
  };

  const mapContainerStyle: CSSProperties = {
    overflow: "hidden",
    backgroundColor: "#f3f4f6",
    height: `${height}px`,
    borderRadius: `${borderRadius}px`,
  };

  const placeholderStyle: CSSProperties = {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#6b7280",
  };

  return (
    <div style={wrapperStyle}>
      {showAddress && address && (
        <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "16px", color: "#374151" }}>
          <span style={{ fontSize: "1.25rem" }}>📍</span>
          <span>{address}</span>
        </div>
      )}
      <div style={mapContainerStyle}>
        {embedUrl ? (
          <iframe
            src={embedUrl}
            title="Google Map"
            style={{ width: "100%", height: "100%", border: 0 }}
            allowFullScreen
            loading="lazy"
          />
        ) : (
          <div style={placeholderStyle}>
            <div style={{ textAlign: "center" }}>
              <span style={{ fontSize: "2.25rem", display: "block", marginBottom: "8px" }}>🗺️</span>
              <span>Map not configured</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
